// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1521":"602232996334e028","3253":"51ca5686f2097f75","4926":"921febb913f93f62","5463":"1ccb8b2c66a1cee9","6850":"3bc205cf1d7ab0ac","7677":"c2daee9082847870"}[chunkId] + ".css";
};